angular.module('app').config(hotelsRouting);

function hotelsRouting($routeProvider) {
  $routeProvider
    .when('/hotels', {
      pageTitle: 'HOTELS',
      template: '<hotels-page></hotels-page>',
      menu: 'products',
      accessPermission: 'index_hotel_accountadmin',
      authReq: true,
    })
    .when('/hotels/new', {
      pageTitle: 'ADD_HOTEL',
      template: '<hotel-page></hotel-page>',
      breadcrumb: {
        label: 'HOTELS',
        parent: 'hotels',
        ajs: true,
      },
      menu: 'products',
      accessPermission: 'create_hotel_accountadmin',
      authReq: true,
    })
    .when('/hotels/:id', {
      params: {
        mode: null,
        activeTab: 0,
      },
      pageTitle: 'HOTEL_OVERVIEW',
      template: '<hotel-page></hotel-page>',
      breadcrumb: {
        label: 'HOTELS',
        parent: 'hotels',
        ajs: true,
      },
      menu: 'products',
      accessPermission: 'show_hotel_accountadmin',
      authReq: true,
    });
}

hotelsRouting.$inject = ['$routeProvider'];
